export default (block) => {
  return {
    ...block,
    hosts: block.hosts.map((host) => ({
      ...host,
      imageUrl: host.image.filename
    }))
  }
}
